import { SearchPage } from "#modules/search/view/SearchPage";

export const SearchPageV2 = () => <SearchPage />;
